import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './components/Theme';
import './App.css';
import Home from './pages/Home';
import Contact from './pages/Contact';
// import Devis from './pages/Devis';
import Page404 from './pages/Page404';
import Mandat from './pages/Mandat';
import CNJE from './pages/CNJE';
import ENSC from './pages/ENSC';
import Services from './pages/Services';
import PolitiqueConfidentialite from './pages/Politique';
import MentionsLegales from './pages/Mentions';
import CGU from './pages/CGU';
import EspaceMembre from './pages/Membre';
import Dashboard from './dashboard/Dashboard';
import Todolist from './dashboard/Todolist';
import Etudes from './dashboard/Etudes';
import SI from './dashboard/SI';
import Kahoot from './dashboard/Kahoot';
import Parametres from './dashboard/Parametres';
import BanniereCookie from './components/BanniereCookie'
import DeveloppementWeb from './pages/services/DeveloppementWeb';
import BaseDeDonnees from './pages/services/BaseDeDonnees';
import IntelligenceArtificielle from './pages/services/IntelligenceArtificielle';
import KnowledgeManagement from './pages/services/KnowledgeManagement';
import UxDesign from './pages/services/UxDesign';
import AnalyseStatistique from './pages/services/AnalyseStatistique';
import AuditErgonomique from './pages/services/AuditErgonomique';
import CCU from './pages/services/CCU';
import ConseilHandicap from './pages/services/ConseilHandicap';

function App() {
  const RoutePrivee = ({ children }) => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user ? children : <Navigate to="/"/>;
  };

  return (
    <ThemeProvider> 
      <div className="min-h-screen w-full">
        <BrowserRouter>
          <BanniereCookie/>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="*" element={<Page404/>}/>
            <Route path="/contact" element={<Contact/>}/>
            <Route path="/services" element={<Services/>}/>
            <Route path="/mandat" element={<Mandat/>}/>
            <Route path="/cnje" element={<CNJE/>}/>
            <Route path="/ensc" element={<ENSC/>}/>
            <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite/>}/>
            <Route path="/mentions-legales" element={<MentionsLegales/>}/>
            <Route path="/cgu" element={<CGU/>}/>
            <Route path="/espace-membre" element={<EspaceMembre/>}/>
            <Route path="/dashboard" element={<RoutePrivee><Dashboard/></RoutePrivee>}/>
            <Route path="/todolist" element={<RoutePrivee><Todolist/></RoutePrivee>}/>
            <Route path="/etudes" element={<RoutePrivee><Etudes/></RoutePrivee>}/>
            <Route path="/si" element={<RoutePrivee><SI/></RoutePrivee>}/>
            <Route path="/kahoot" element={<RoutePrivee><Kahoot/></RoutePrivee>}/>
            <Route path="/parametres" element={<RoutePrivee><Parametres/></RoutePrivee>}/>
             <Route path="/services/developpement-web" element={<DeveloppementWeb />} />
             <Route path="/services/base-de-donnees" element={<BaseDeDonnees />} />
             <Route path="/services/intelligence-artificielle" element={<IntelligenceArtificielle />} />
             <Route path="/services/knowledge-management" element={<KnowledgeManagement />} />
             <Route path="/services/ux-design" element={<UxDesign />} />
             <Route path="/services/analyse-statistique" element={<AnalyseStatistique />} />
             <Route path="/services/audit-ergonomique" element={<AuditErgonomique />} />
             <Route path="/services/ccu" element={<CCU />} />
             <Route path="/services/conseil-handicap" element={<ConseilHandicap />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;